module.exports = __webpack_public_path__ + "static/media/wsymbol_0018_cloudy_with_heavy_rain_big_s1.1972f21f.png";